import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoksun-duygusal-etkileri/page.tsx");
